import React from "react";
import "../MainStart.css";

/**
 * SimpleCard – flexible Card-Komponente
 *
 * Props:
 * - title: string
 * - description: string | React.ReactNode
 * - icon: React.ReactNode (z.B. <img />, ein SVG oder ein Icon-Component)
 * - backgroundColor?: string
 * - titleColor?: string
 * - textColor?: string
 * - className?: string (zusätzliche CSS-Klassen)
 * - onClick?: () => void
 */
const SimpleCard = ({
    title,
    description,
    icon,
    backgroundColor = "#00000025",    // sehr dunkles Blau/Schwarz
    titleColor = "var(--accent)",          // grün wie im Screenshot
    textColor = "#e5e7eb",           // leicht graues Weiß
    className = "",
    onClick,
    ...rest
}) => {
    const isClickable = typeof onClick === "function";

    return (
        <div
            onClick={onClick}
            className={className}
            style={{
                // backgroundColor,
                // borderRadius: "14px",
                // // padding: "18px 20px",
                // display: "flex",
                // flexDirection: "column",
                // gap: "10px",
                // maxWidth: "320px",
                // border: "2px solid rgba(255, 255, 255, 0.3)",
                // // boxShadow: "0 10px 25px rgba(0,0,0,0.35)",
                // cursor: isClickable ? "pointer" : "default",
                // transition: "transform 0.12s ease-out, box-shadow 0.12s ease-out",
            }}
            // onMouseEnter={(e) => {
            //     if (!isClickable) return;
            //     e.currentTarget.style.transform = "translateY(-2px)";
            //     e.currentTarget.style.boxShadow = "0 14px 30px rgba(0,0,0,0.45)";
            // }}
            // onMouseLeave={(e) => {
            //     if (!isClickable) return;
            //     e.currentTarget.style.transform = "translateY(0)";
            //     e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.35)";
            // }}
            {...rest}
        >
            {/* Icon */}
            {icon && (
                <div style={{ textAlign: "center", marginBottom: "4px" }}>
                    {icon}
                </div>
            )}

            {/* Titel */}
            <h3
                style={{
                    margin: 0,
                    color: titleColor,
                    fontSize: "1.05rem",
                    fontWeight: 700,
                }}
            >
                {title}
            </h3>

            {/* Beschreibung */}
            <p
                style={{
                    textAlign: "center",
                    margin: 0,
                    color: textColor,
                    fontSize: "0.9rem",
                    lineHeight: 1.4,
                }}
            >
                {description}
            </p>
        </div>
    );
};

export default SimpleCard;
